export default function routerWithSidebar(component: () => Promise<any>) {
  return {
    default: component,
    sidebar: () =>
      import(/* webpackChunkName: "Sidebar" */ "@/components/common/Sidebar/index.vue")
  };
}
